import React, { useState, useEffect, useMemo } from 'react';
import './ExcelAccount.css';
import { format } from 'date-fns';

const ExcelAccount = () => {
  const [form, setForm] = useState({
    partner_name: '',
    transaction_type: 'Credited',
    amount: '',
    transaction_mode: 'UPI',
    date_of_payment: '',
    description: '',
  });
  const [partners, setPartners] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState('');
  const [history, setHistory] = useState([]);
  const [totals, setTotals] = useState({ total_credited: 0, total_debited: 0 });

  // Calculate running balances for each transaction using useMemo
  const transactionBalances = useMemo(() => {
    const balanceMap = {};
    const partnerBalances = {};
    
    // Sort transactions by date and ID to process chronologically
    const sortedTransactions = [...history].sort((a, b) => {
      const dateA = new Date(a.date_of_payment || 0);
      const dateB = new Date(b.date_of_payment || 0);
      if (dateA.getTime() === dateB.getTime()) {
        return (a.id || 0) - (b.id || 0);
      }
      return dateA - dateB;
    });

    // Calculate running balance for each transaction
    sortedTransactions.forEach((entry) => {
      const partnerName = entry.partner_name;
      if (!partnerBalances[partnerName]) {
        partnerBalances[partnerName] = 0;
      }
      
      // Update balance based on transaction type
      if (entry.transaction_type === 'Credited') {
        partnerBalances[partnerName] += Number(entry.amount || 0);
      } else if (entry.transaction_type === 'Debited') {
        partnerBalances[partnerName] -= Number(entry.amount || 0);
      }
      
      // Store the balance after this transaction
      balanceMap[entry.id] = partnerBalances[partnerName];
    });

    return balanceMap;
  }, [history]);

  const fetchHistory = async (partner = '') => {
    try {
      const url = partner
  ? `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/excel-account-history?partner=${partner}`
  : `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/excel-account-history`;

const response = await fetch(url);
const data = await response.json();

      const historyData = data.history || [];
      setHistory(historyData);
      setPartners(data.partners || []);
      setTotals(data.totals || { total_credited: 0, total_debited: 0 });
    } catch (error) {
      console.error('Error fetching history:', error);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.partner_name || !form.amount || !form.date_of_payment) {
      alert('Please fill all required fields.');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/add-excel-account-transaction`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(form),
});


      const data = await response.json();
      if (response.ok) {
        alert('Transaction added successfully');
        setForm({
          partner_name: '',
          transaction_type: 'Credited',
          amount: '',
          transaction_mode: 'UPI',
          date_of_payment: '',
          description: '',
        });
        setHistory(data.history || []);
        setTotals(data.totals || { total_credited: 0, total_debited: 0 });
      } else {
        alert(data.error || 'Error adding transaction');
      }
    } catch (error) {
      console.error('Error submitting transaction:', error);
    }
  };

  return (
    <div className="finance-container">
      <h2>Excel Account Transactions</h2>

     <div className="totals">
  <h3>
    Total Credited: ₹
    {Number(totals.total_credited || 0).toFixed(2)}
  </h3>
  <h3>
    Total Debited: ₹
    {Number(totals.total_debited || 0).toFixed(2)}
  </h3>
</div>

      <div className="add-credit-form">
        <select
          name="partner_name"
          value={form.partner_name}
          onChange={handleChange}
          required
        >
          <option value="">Select Partner</option>
          <option value="LAXMIKANTH CHINCHURE">LAXMIKANTH CHINCHURE</option>
          <option value="GURURAJ CHINCHURE">GURURAJ CHINCHURE</option>
          <option value="SHRISHAIL MANTAGI">SHRISHAIL MANTAGI</option>
          <option value="AKASH BIRAJDAR">AKASH BIRAJDAR</option>
          <option value="MALLIKARJUN CHINCHURE">MALLIKARJUN CHINCHURE</option>
          <option value="SHARANU KUMBAR">SHARANU KUMBAR</option>
          <option value="SIDDARAM DHAGE">SIDDARAM DHAGE</option>
          <option value="VAIJUNATH KORE">VAIJUNATH KORE</option>
          <option value="GURUSHANTH WADAGAON">GURUSHANTH WADAGAON</option>
          <option value="MAHESH HADAPAD">MAHESH HADAPAD</option>
          <option value="SADANAND KARAGIR">SADANAND KARAGIR</option>
          <option value="GURU BANDE">GURU BANDE</option>
        </select>
        <select name="transaction_type" value={form.transaction_type} onChange={handleChange}>
          <option value="Credited">Credited</option>
          <option value="Debited">Debited</option>
        </select>
        <input
          type="number"
          name="amount"
          value={form.amount}
          onChange={handleChange}
          placeholder="Amount"
          required
        />
        <select name="transaction_mode" value={form.transaction_mode} onChange={handleChange}>
          <option value="UPI">UPI</option>
          <option value="Cash">Cash</option>
        </select>
        <input
          type="date" 
          name="date_of_payment"
          value={form.date_of_payment}
          onChange={handleChange}
          required
        />
        <textarea
          name="description"
          value={form.description}
          onChange={handleChange}
          placeholder="Description (optional)"
        ></textarea>
        <button onClick={handleSubmit}>Submit</button>
      </div>

      <div className="filter-section">
        <label>Filter by Partner: </label>
        <select value={selectedPartner} onChange={(e) => {
          const partner = e.target.value;
          setSelectedPartner(partner);
          fetchHistory(partner);
        }}>
          <option value="">All</option>
          {partners.map((partner, idx) => (
            <option key={idx} value={partner}>{partner}</option>
          ))}
        </select>
      </div>

      <h3>Transaction History</h3>
<div className="history-table-container">
  {history.length > 0 ? (
    <table className="history-table">
      <thead>
        <tr>
          <th>Partner Name</th>
          <th>Type</th>
          <th>Amount (₹)</th>
          <th>Mode</th>
          <th>Date</th>
          <th>Description</th>
          <th>Remaining Balance</th>
        </tr>
      </thead>
      <tbody>
        {[...history]
          .sort((a, b) => {
            // Sort by date descending (newest first), then by ID descending
            const dateA = new Date(a.date_of_payment || 0);
            const dateB = new Date(b.date_of_payment || 0);
            if (dateB.getTime() === dateA.getTime()) {
              return (b.id || 0) - (a.id || 0);
            }
            return dateB - dateA;
          })
          .map((entry) => {
            const runningBalance = transactionBalances[entry.id] || 0;
            return (
              <tr key={entry.id}>
                <td>{entry.partner_name}</td>
                <td
                  className={
                    entry.transaction_type === 'Credited'
                      ? 'credited'
                      : 'debited'
                  }
                >
                  {entry.transaction_type}
                </td>
                <td>{Number(entry.amount).toFixed(2)}</td>
                <td>{entry.transaction_mode}</td>
                <td>
                  {entry.date_of_payment
                    ? format(new Date(entry.date_of_payment), 'dd-MM-yyyy')
                    : 'N/A'}
                </td>
                <td>{entry.description || '-'}</td>
                <td className={runningBalance >= 0 ? 'balance-positive' : 'balance-negative'}>
                  ₹{runningBalance.toFixed(2)}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  ) : (
    <p className="no-history">No transactions yet.</p>
  )}
</div>

    </div>
  );
};

export default ExcelAccount;

